import { createSlice } from "@reduxjs/toolkit";

// NOTE: Profile reducer no longer restores from storage
// Redux Persist handles Login reducer persistence
// Profile reducer gets user from Login reducer via Redux selectors
export const initialState = {
  error: "",
  success: "",
  user: {}, // Redux Persist will restore Login state, Profile gets user from Login reducer
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    profileSuccess(state, action) {
      state.success = action.payload.status;
      state.user = action.payload.data;
    },
    profileError(state, action) {
      state.error = action.payload;
    },
    editProfileChange(state) {
      state = { ...state };
    },
    resetProfileFlagChange(state: any) {
      state.success = null;
    },
  },
});

export const {
  profileSuccess,
  profileError,
  editProfileChange,
  resetProfileFlagChange,
} = ProfileSlice.actions;

export default ProfileSlice.reducer;
